import TangramOptions from "./TangramOptions";
import Tangrams from "./Tangrams"
import { useEffect, useState } from "react";

export default function Level6_AdvancedTangrams(props) {
  return (
    <Tangrams {...props} plevel="Level3" img="SeaTurtle" progression={true} ></Tangrams >
  )
}

